<template>
  <div>
    <div id="no-cv-top">
      <a key=""
        href="https://landing.drushim.co.il/?ref=286"
        class="white--text no-underline"
        target="_blank"
      >
      מחפשים עובדים? יש לנו הצעות מיוחדות &gt;&gt;
      </a>
    </div>
    <div class="top-board-wrap">
      <TopBoard />
    </div>
    <SectionCompaniesNew v-if="mountedPage" />

    <div class="recommender-holder">
      <Recommender
        :currentPage="'recommender_HomePage'"
        :maxJobs="$vuetify.breakpoint.xsOnly ? 5 : 5"
        :forwardToJobPage="false"
        :displayType="$vuetify.breakpoint.xsOnly ? 3 : 0"
        :displayJobDescription="true"
        :headerDisplay="true"
      />
    </div>
    <EarnBtn />
    <SectionMentors />

    <VideoModal />
    <SectionTips />
    <SectionSeo class="mt-6" />
    <CvConfirmation />
  </div>
</template>

<script>
import TopBoard from '~/components/HomePageComponents/TopBoard';
import SectionSeo from '~/components/HomePageComponents/SectionSeo';
import SectionTips from '~/components/HomePageComponents/SectionTips';
import SectionMentors from '~/components/HomePageComponents/SectionMentors';
import EarnBtn from '~/components/Banners/EarnBtn';

import inAppGtmOnce from '@/components/mixins/inAppGtmOnce';
import Recommender from '@/components/Recommender/Recommender';
import CvConfirmation from '@/components/Dialogs/CvConfirmation/CvConfirmation';
import VideoModal from '@/components/VideoModal';

import {
  fetcCSV,
  pirsumstat,
  bannerstat,
  divurRedirect
} from '@/lib/redirects.js';
import { gtm } from '@/lib/gtm.js';

export default {
  layout: 'default',
  name: 'homePage',
  mixins: [inAppGtmOnce],
  components: {
    SectionCompaniesNew: () =>
      import(/* webpackPrefetch: true */ '~/components/HomePageComponents/SectionCompaniesNew'),
    TopBoard,
    EarnBtn,
    SectionSeo,
    SectionTips,
    Recommender,
    CvConfirmation,
    SectionMentors,
    VideoModal
  },

  data() {
    return {
      dialog: true,
      isMobile: false,
      mountedPage: false,
      organizationSchema: {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'DRUSHIM IL',
        url: 'https://www.drushim.co.il/',
        logo: 'https://www.drushim.co.il/images/logo.png',
        sameAs: [
          'https://www.facebook.com/drushim.co.il?mibextid=ZbWKwL',
          'https://www.linkedin.com/company/portal-drushim-israel',
          'https://www.youtube.com/@drushim',
          'https://www.instagram.com/drushim__il/?igshid=NTc4MTIwNjQ2YQ%3D%3D'
        ]
      }
    };
  },
  mounted() {
    this.mountedPage = true;
    this.isMobile = window.innerWidth < 600;
    /**
     * Generates csv file
     * @param {route.path} String - The target url
     */
    this.statisticsRouter();
    this.showOTPModalIfNeeded();
    this.gtmLogIfLoggedIn();
  },

  // check redirect on server side
  async fetch(context) {
    /**All query from url pass to server */
    let queryParamsFullPath = context.route.fullPath.split('?')[1];

    /**path name without queryparams (bannerstat.aspx) */
    let currentPath = context.route.path
      .split('.')[0]
      .split('/')[1]
      .toLowerCase();

    let queryParamsKeys = context.route.query;

    let checkQueryKeysExists =
      queryParamsKeys.hasOwnProperty('ctid') &&
      queryParamsKeys.hasOwnProperty('sct') &&
      queryParamsKeys.hasOwnProperty('utm_source');

    if (checkQueryKeysExists) {
      try {
        const { IsRedirect, RedirectTo } = await divurRedirect(
          context.$axios,
          queryParamsFullPath
        );
        if (IsRedirect) {
          return context.redirect(307, RedirectTo);
        }
      } catch (e) {
        console.log('divurRedirect - Error');
        return context.redirect(307, '/');
      }
    }

    switch (currentPath) {
      case 'bannerstat': {
        try {
          var bannerstatRes = await bannerstat(
            context.$axios,
            queryParamsFullPath
          );
          var { IsRedirect, RedirectTo } = bannerstatRes.data;
          if (IsRedirect) {
            return context.redirect(307, RedirectTo);
          }
        } catch (e) {
          console.log('bannerstat.aspx - Error');
          return context.redirect(307, '/');
        }

        break;
      }
      case 'pirsumstat': {
        try {
          var pirsumstatRes = await pirsumstat(
            context.$axios,
            queryParamsFullPath
          );
          const { IsRedirect, RedirectTo } = pirsumstatRes.data;
          if (IsRedirect) {
            return context.redirect(307, RedirectTo);
          }
        } catch (e) {
          console.log('pirsumstat.aspx - Error');
          return context.redirect(307, '/');
        }
        break;
      }
      default:
        break;
    }
  },

  methods: {
    currentRouteName() {
      return this.$route.path;
    },
    currentRouteQuery() {
      let fullpath = this.$route.fullPath.split('?')[1];

      return fullpath;
    },
    //check redirects on client side
    async statisticsRouter() {
      let currentRoute = this.currentRouteName().toLowerCase();
      switch (currentRoute) {
        case '/csv':
          await fetcCSV(this.$axios);
          break;

        default:
          break;
      }
    },
    gtmLogIfLoggedIn() {
      const isLoggedIn = this.$store.getters?.isLogged ?? false;
      const id = this.$auth?.user?.UserProfile?.UserId ?? 0;

      if (isLoggedIn) {
        gtm({
          event: 'session_login',
          user_id: id
        });
      }
    },
    showOTPModalIfNeeded() {
      const isLoggedIn = this.$store.getters?.isLogged ?? false;

      if (isLoggedIn) {
        this.$nextTick(() => {//waits for the DOM to update
          this.$nuxt.$emit('openOTP', 'default');
        });
      }
    }
  },

  head() {
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.organizationSchema),
          type: 'application/ld+json'
        }
      ]
    };
  }
};
</script>



<style lang="sass" scoped>
#no-cv-top
  display: flex
  justify-content: center
  align-items: center
  background: #3c4953
  color: #fff
  position: relative
  height: 55px
  a
    font-size: 18px

  .no-cv-stamp
    position: absolute
    top: -21px
    left: 0
    right: -57px

@media only screen and (min-width: 600px)
  #no-cv-top
    height: 65px
    a
      font-size: 25px
</style>
